import { Box } from '@mui/material';

// project import

// assets

// ==============================|| HEADER CONTENT - MEGA MENU SECTION ||============================== //

const MegaMenuSection = () => {
  return <Box sx={{ flexShrink: 0, ml: 0.75 }}></Box>;
};

export default MegaMenuSection;
